@if (attachmentsTemplate.showTemplate) {
  <div class="common-lateral-panel"
    [ngClass]="{'common-lateral-panel--expand':attachmentsTemplate.fullScreen,
        'common-lateral-panel--no-content':!attachmentsTemplate.attachmentList.length && attachmentsTemplate.closeSpinner && typeFrom !== 'documentReference' && (attachmentsTemplate.itemSelected?.conceptId || typeFrom === 'task' || typeFrom === 'preview')
    }">
    <div class="common-section-title__lp-container">
      <div class="common-section-title__lp-title-icon">
        <i class="lf-icon-add common-icon__lg"></i>
        <span class="common-section-title__lp-label-text"
          [afTranslate]="attachmentsTemplate.itemSelected?.taskTypeId === 2?'attach-document.documents-to-sign':'attachments.documents'">
          _Documentos adjuntos</span>
      </div>
      @if(userPermissions !== 'none'){
        <div class="common-section-title__dp-buttons-container">
          @if(!isLanding){
            <button-with-menu-action
              [item]="attachmentsTemplate.itemOptions"
              [icon]="'lf-icon-add-round'"
              [disabled]="(attachmentsTemplate.hideAddDocuments)"
              (configureMenuEmitter)="configureItemOptions()"
              (launchActionEmitter)="launchActionDocuments($event.action)">
            </button-with-menu-action>
          }@else if(!attachmentsTemplate.concept.anonymized && !attachmentsTemplate.icamConceptObject){
            <button
              class="common-button__icon-md-noborder"
              [disabled]="lockComToManager || attachmentsTemplate.hideAddDocuments || typeFrom === 'preview' || attachmentsTemplate.concept.sharedReadOnly"
              (click)="launchActionDocuments('upDocument')">
              <i class="common-icon__md lf-icon-add-round"></i>
            </button>
          }
        </div>
      }
    </div>
    @if (lockComToManager){
      <div class="common-status-message__s-container-warning">
        <span class="common-status-message__s-title"
          [afTranslate]="'attachments.no-permissions-to-add'">
          _No puedes adjuntar nuevos documentos en este punto del proceso de la comunicación.</span>
      </div>
    }
    <div class="common-lateral-panel__body"
      [ngClass]="{'common-lateral-panel__body--no-content': !attachmentsTemplate.attachmentList.length && attachmentsTemplate.closeSpinner && typeFrom !== 'documentReference' && (attachmentsTemplate.itemSelected?.conceptId || typeFrom === 'task' || typeFrom === 'preview')}">
      @if (attachmentsTemplate.attachmentList.length || typeFrom === 'documentReference'){
        <ul class="common-lateral-panel__list-items common-attachments-panel__list">
          @for (document of attachmentsTemplate.attachmentList; track $index) {
            <li class="common-lateral-panel__item common-attachments-panel__list-item">
              <span [class]="'common-icon__md ' + (document.extension | extensionDocument:'md')"></span>
              <div class="common-lateral-panel__document-text-info">
                <div class="common-lateral-panel__link-text">
                  <button class="common-button__link overflow-hidden"
                    [disabled]="userPermissions === 'none' || !document.officeOnlineType || !(attachmentsTemplate.itemSelected?.conceptObjectId || attachmentsTemplate.itemSelected?.taskId || (attachmentsTemplate.itemSelected?.conceptId && document.sharedPublicConceptDocumentId))"
                    (click)="launchActionDocuments('download' , document)">
                    <span-tooltip
                      (click)="launchActionDocuments('download', document)"
                      class="common-lateral-panel__document-title"
                      [text]="document.name">
                    </span-tooltip>
                  </button>
                </div>
                <div class="common-lateral-panel__item-text w-[100px]">{{ (document.modified ?? document.creationDate) | convertDate:'without-time' }}</div>
                <div class="common-lateral-panel__item-text w-[50px] landing-page__tablet"> {{document.fileSize | convertBytes}}</div>
              </div>
              <!-- @if (!document.hideDeleteOption) {-->
              <!-- @if (configureCanBeDeletedDocument(document)) {
                <button class="common-lateral-panel__button-action"
                  pTooltip="{{'common.remove-document' | afTranslate}}"
                  tooltipPosition="top"
                  (click)="launchActionDocuments('delete' , document)">
                  <i class="lf-icon-trash common-icon__md"></i>
                </button>
              } -->
              @if (!document.hideDeleteOption) {
                <!-- Mostrar botón de borrado si está permitido -->
                <button
                  class="common-lateral-panel__button-action"
                  pTooltip="{{'common.remove-document' | afTranslate}}"
                  tooltipPosition="top"
                  (click)="launchActionDocuments('delete', document)">
                  <i class="lf-icon-trash common-icon__md"></i>
                </button>
              }
            </li>
          }
        </ul>
      } @else if(!attachmentsTemplate.attachmentList.length && typeFrom !== 'documentReference' && attachmentsTemplate.closeSpinner && (attachmentsTemplate.itemSelected?.conceptId || typeFrom === 'task' || typeFrom === 'preview')){
        <p class="common-lateral-panel__no-content"
          [afTranslate]="'attachments.without-documents'">_No hay documentos adjuntos</p>
      }
    </div>
    @if (attachmentsTemplate.attachmentList?.length > 3) {
      <div class="common-lateral-panel__expand-block">
        <div class="common-lateral-panel__expand-total-block">
          <p class="common-lateral-panel__expand-total-text">
            <span [afTranslate]="'common.total'">_Total</span>
            <span class="pr-1">:</span>
            <span>{{attachmentsTemplate.attachmentList?.length}}</span>
          </p>
        </div>
        <button class="common-button__expand-toned"
          (click)="attachmentsTemplate.fullScreen = !attachmentsTemplate.fullScreen">
          <i class=" common-icon__md"
          [ngClass]="attachmentsTemplate.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
          <span class="common-button__expand-label-text"
            [afTranslate]="attachmentsTemplate.fullScreen?'common.collapse':'common.expand'"></span>
        </button>
      </div>
    }
  </div>
}
